'use client';

import { useState } from 'react';
import { updateGeneralSettings } from '../api';
import type { GeneralSettings } from '../types';

export function useUpdateGeneralSettings() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const mutateAsync = async (
    tenantSlug: string, 
    file?: File | null, 
    employeeIdPrefix?: string
  ): Promise<GeneralSettings> => {
    try {
      setIsLoading(true);
      setError(null);
      return await updateGeneralSettings(tenantSlug, file, employeeIdPrefix);
    } catch (err) {
      const errorObj = err instanceof Error ? err : new Error('Failed to update general settings');
      setError(errorObj);
      throw errorObj;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    mutateAsync,
    isLoading,
    error,
  };
}
